import { Component, OnInit, Input } from '@angular/core';
import { UserDTO } from 'src/app/shared/dtos/UserDTO';
import { AuthService } from 'src/app/util/services/auth.service';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit {

  userLogged: UserDTO;

  constructor(
    private authService: AuthService) { }

  ngOnInit() {
    this.getUser();
  }

  getUser(): void {
    this.authService.getCurrentUser()
      .subscribe(user => {
        this.userLogged = user;
      });
  }

}
